import { render, staticRenderFns } from "./MenuItemSubGroup.html?vue&type=template&id=7aa9a02a&scoped=true&"
import script from "./MenuItemSubGroup.ts?vue&type=script&lang=ts&"
export * from "./MenuItemSubGroup.ts?vue&type=script&lang=ts&"
import style0 from "./MenuItemSubGroup.scss?vue&type=style&index=0&id=7aa9a02a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa9a02a",
  null
  
)

export default component.exports